import { render, staticRenderFns } from "./EditarChofer.vue?vue&type=template&id=6cf2ec86&"
import script from "./EditarChofer.vue?vue&type=script&lang=js&"
export * from "./EditarChofer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports